// OPS Occult Library comparative visual archive v2 — Zeghere van Male Songbook source pack.
(()=>{
  const TITLE='zeghere van male songbook — grotesque letters in the margins of music';
  const SOURCES=[
    {
      date:'1542',
      period:'Mid-16th-century Renaissance',
      creator:'Single manuscript scribe/illuminator, probably the “g h” named on several folios; exact identity uncertain',
      work:'Songbook of Zeghere van Male — superius fol. 13v',
      page:'Superius / Discantus fol. 13 verso; Cambrai MS 128',
      institution:'Le Labo, Cambrai (formerly Médiathèque municipale / Bibliothèque municipale)',
      collection:'Cambrai MS 128, one of the Zeghere van Male partbooks MSS 125–128',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Songbook_of_Zeghere_van_Male_-_superius_013_verso.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Songbook_of_Zeghere_van_Male_-_superius_013_verso.jpg',
      rights:'Public-domain historical manuscript; Commons identifies the reproduction as public domain / free of known copyright restrictions',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Songbook of Zeghere van Male, 1542, superius fol. 13v, Cambrai MS 128, Le Labo, Cambrai. Public-domain reproduction via Wikimedia Commons.',
      note:'The existing lead image preserves the whole-page relationship between notation, text, parchment and decorated initial rather than isolating the ornament from the music manuscript.'
    },
    {
      date:'1542',
      period:'Mid-16th-century Renaissance',
      creator:'Artist known only as “g h”',
      work:'Songbook of Zeghere van Male — illuminated capital Q',
      page:'Superius fol. 30 recto; source page within Cambrai MS 128',
      institution:'Le Labo, Cambrai',
      collection:'Cambrai MS 128 / Zeghere van Male partbooks',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Zeghere_s030r_capital_Q.jpg?width=1000',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Zeghere_s030r_capital_Q.jpg',
      rights:'Public domain; Commons file page states the 1542 work is public domain',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Artist known as “g h”, illuminated capital Q, Songbook of Zeghere van Male, 1542, superius fol. 30r, Cambrai MS 128. Public domain via Wikimedia Commons.',
      note:'This crop makes the letter skeleton easier to study: the miniature inhabits the character rather than replacing its readable silhouette.'
    },
    {
      date:'1542',
      period:'Mid-16th-century Renaissance',
      creator:'Artist known only as “g h”',
      work:'Songbook of Zeghere van Male — illuminated capital E',
      page:'Superius fol. 43 recto; source page within Cambrai MS 128',
      institution:'Le Labo, Cambrai',
      collection:'Cambrai MS 128 / Zeghere van Male partbooks',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Zeghere_s043r_capital_E.jpg?width=1000',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Zeghere_s043r_capital_E.jpg',
      rights:'Public domain; Commons file page states the 1542 work is public domain',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Artist known as “g h”, illuminated capital E, Songbook of Zeghere van Male, 1542, superius fol. 43r, Cambrai MS 128. Public domain via Wikimedia Commons.',
      note:'A second letterform shows how the manuscript reuses the idea of a historiated initial without settling into one fixed decorative formula.'
    },
    {
      date:'1542',
      period:'Mid-16th-century Renaissance',
      creator:'Artist known only as “g h”',
      work:'Songbook of Zeghere van Male — illuminated capital S',
      page:'Superius fol. 47 recto; source page within Cambrai MS 128',
      institution:'Le Labo, Cambrai',
      collection:'Cambrai MS 128 / Zeghere van Male partbooks',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Zeghere_s047r_capital_S.jpg?width=1100',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Zeghere_s047r_capital_S.jpg',
      rights:'Public domain; Commons file page states the 1542 work is public domain',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Artist known as “g h”, illuminated capital S, Songbook of Zeghere van Male, 1542, superius fol. 47r, Cambrai MS 128. Public domain via Wikimedia Commons.',
      note:'The curved S gives a useful contrast with the more architectural E and Q, showing how figural ornament adapts to different letter rhythms.'
    },
    {
      date:'1542',
      period:'Mid-16th-century Renaissance',
      creator:'Artist known only as “g h”',
      work:'Songbook of Zeghere van Male — illuminated capital E',
      page:'Superius fol. 60 verso; source page within Cambrai MS 128',
      institution:'Le Labo, Cambrai',
      collection:'Cambrai MS 128 / Zeghere van Male partbooks',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Zeghere_s060v_capital_E.jpg?width=1000',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Zeghere_s060v_capital_E.jpg',
      rights:'Public domain; Commons file page states the 1542 work is public domain',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Artist known as “g h”, illuminated capital E, Songbook of Zeghere van Male, 1542, superius fol. 60v, Cambrai MS 128. Public domain via Wikimedia Commons.',
      note:'Comparing this E with fol. 43r demonstrates variation inside the same manuscript: the letter remains recognisable while scene, gesture and internal drawing change.'
    }
  ];
  const key=(value)=>String(value||'').trim().toLowerCase();
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
